export const WINDOW_EVENT_IS_LAST_POINTER_MOUSE = "isLastInputWasMouse";
export const WINDOW_KEY_IS_LAST_POINTER_MOUSE = "isLastInputWasMouse";

export const dispatchCustomEventLastInputWasMouseChange = (isLastInputWasMouse) => {
  window.dispatchEvent(new CustomEvent(WINDOW_EVENT_IS_LAST_POINTER_MOUSE, {
    detail: isLastInputWasMouse,
  }));
};
